export default "__VITE_ASSET__LBQiZmYK__"